import React from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  return (
    <header className='bg-[#F4F6F9] py-[15px] shadow-md w-full'>
      <div className='flex justify-start px-10 mx-auto w-full'>
        <div className='flex justify-start items-center pl-0'>
          <Link to='/'>
            <img
              src='/logo/logo.svg'
              alt='Takagi Seiko Logo'
              className='h-auto w-auto max-h-[60px] object-contain [image-rendering:crisp-edges] cursor-pointer'
            />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
